import { render } from "./GrigliaRicambi.vue?vue&type=template&id=404ee17e"
import script from "./GrigliaRicambi.vue?vue&type=script&lang=js"
export * from "./GrigliaRicambi.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Ecommerce\\CONAD_MANUTENZIONI\\conad-manutenzioni\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__